import React, { useEffect, useState } from 'react';
import useAuth from '../../pages/useAuth';
import PageLoder from '../../components/PageLoader';
import { Card, Row, Col, Form, Button, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const LAB_DIRECTOR_Dashboard = () => {
     useAuth();
     const [dashboardData, setDashboardData] = useState(null);
     const baseUrl = process.env.REACT_APP_BASE_URL || '';
     const [filters, setFilters] = useState({ emp_code: '', quarter: '', year: new Date().getFullYear().toString() });
     const navigate = useNavigate();

     useEffect(() => {
          const fetchDashboardData = async () => {
               try {
                    const token = localStorage.getItem('token');
                    const headers = { Accept: 'application/json' };
                    if (token) headers.Authorization = `Bearer ${token}`;

                    const params = new URLSearchParams();
                    if (filters.emp_code) params.set('emp_code', filters.emp_code);
                    if (filters.quarter) params.set('quarter', filters.quarter);
                    if (filters.year) params.set('year', filters.year);

                    const base = baseUrl ? `${baseUrl}/getLabAdminDashboardData` : '/getLabAdminDashboardData';
                    const url = params.toString() ? `${base}?${params.toString()}` : base;

                    const response = await fetch(url, {
                         method: 'GET',
                         headers,
                    });
                    const data = await response.json();
                    setDashboardData(data);
                    try {
                         console.debug('LAB_DIRECTOR_Dashboard: fetched dashboardData', data);
                         const evals = Array.isArray(data?.evaluationsList) ? data.evaluationsList : (data?.evaluations || []);
                         const serverPending = data?.metrics?.pendingAdminCount;
                         const clientPending = (evals || []).filter(ev => {
                              const adminCode = ev && (ev.admin_emp_code || ev.adminCode || ev.admin_emp || ev.admin_empcode);
                              const adminName = ev && (ev.admin_name || ev.adminName || ev.admin);
                              return !(adminCode || adminName);
                         }).map(e => e.id || e.emp_code || JSON.stringify(e));
                         console.debug('LAB_DIRECTOR_Dashboard: serverPendingCount', serverPending, 'clientPendingIds', clientPending);
                    } catch (e) { console.debug('dashboard debug failed', e); }
               }
               catch (error) {
                    console.error('Error fetching dashboard data:', error);
               }
          };
          fetchDashboardData();
     }, [baseUrl, filters]);




     const quarters = [{ value: '', label: 'All' }, { value: 'Q1', label: 'Jan - Mar (Q1)' }, { value: 'Q2', label: 'Apr - Jun (Q2)' }, { value: 'Q3', label: 'Jul - Sep (Q3)' }, { value: 'Q4', label: 'Oct - Dec (Q4)' },];
     const years = (() => {
          const y = new Date().getFullYear();
          const arr = [];
          for (let i = 0; i < 2; i++) arr.push(y - i);
          return arr;
     })();

     const consultants = dashboardData?.consultantsList || [];
     const evaluations = dashboardData?.evaluationsList || [];
     const metrics = dashboardData?.metrics || {};
     const computedPendingAdminCount = (() => {
          const evals = Array.isArray(dashboardData?.evaluationsList) ? dashboardData.evaluationsList : (dashboardData?.evaluations || []);
          if (!Array.isArray(evals)) return metrics.pendingAdminCount ?? 0;
          return evals.filter(ev => {
               const adminCode = ev && (ev.admin_emp_code || ev.adminCode || ev.admin_emp || ev.admin_empcode);
               const adminName = ev && (ev.admin_name || ev.adminName || ev.admin);
               return !(adminCode || adminName);
          }).length;
     })();
     const computedCompletedAdminCount = (() => {
          const evals = Array.isArray(dashboardData?.evaluationsList) ? dashboardData.evaluationsList : (dashboardData?.evaluations || []);
          if (!Array.isArray(evals)) return metrics.completedAdminCount ?? 0;
          return evals.filter(ev => {
               const adminCode = ev && (ev.admin_emp_code || ev.adminCode || ev.admin_emp || ev.admin_empcode);
               const adminName = ev && (ev.admin_name || ev.adminName || ev.admin);
               return Boolean(adminCode || adminName);
          }).length;
     })();
     const [currentPage, setCurrentPage] = useState(1);
     const [pageSize, setPageSize] = useState(10);
     const [showPendingAdmin, setShowPendingAdmin] = useState(false);

     // reset to first page when filters or data change
     useEffect(() => {
          setCurrentPage(1);
     }, [filters.emp_code, filters.quarter, filters.year, evaluations.length, pageSize, showPendingAdmin]);

     // apply client-side pending-admin filter when requested
     const filteredEvaluations = (evaluations || []).filter(ev => {
          if (!showPendingAdmin) return true;
          // pending admin review: admin_emp_code/admin_name missing or empty
          const adminCode = ev && (ev.admin_emp_code || ev.adminCode || ev.admin_emp || ev.admin_empcode);
          const adminName = ev && (ev.admin_name || ev.adminName || ev.admin);
          const hasAdmin = adminCode || adminName;
          return !hasAdmin;
     });

     const totalPages = Math.max(1, Math.ceil((filteredEvaluations.length || 0) / pageSize));
     const paginatedEvaluations = (filteredEvaluations || []).slice((currentPage - 1) * pageSize, currentPage * pageSize);

     const formatDateOnly = (s) => {
          if (!s) return '';
          try {
               let ds = String(s).trim();
               if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(ds)) ds = ds.replace(' ', 'T');
               const d = new Date(ds);
               if (!isNaN(d.getTime())) {
                    const dd = String(d.getDate()).padStart(2, '0');
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const yyyy = d.getFullYear();
                    return `${dd}-${mm}-${yyyy}`;
               }
          } catch (e) { }
          return String(s).split('T')[0] || String(s);
     };

     const computeVdc = (dojStr) => {
          if (!dojStr) return '';
          let ds = String(dojStr).trim();
          if (!ds || ds === '0000-00-00' || ds === '0000-00-00 00:00:00') return '';
          try {
               let d = null;
               if (/^\d{4}-\d{2}-\d{2}/.test(ds)) {
                    d = new Date(ds.split(' ')[0]);
               } else if (/^\d{2}-\d{2}-\d{4}$/.test(ds)) {
                    const [dd, mm, yyyy] = ds.split('-');
                    d = new Date(`${yyyy}-${mm}-${dd}`);
               } else {
                    const tmp = new Date(ds);
                    if (!isNaN(tmp.getTime())) d = tmp;
               }
               if (!d || isNaN(d.getTime())) return '';
               const now = new Date();
               const months = (now.getFullYear() - d.getFullYear()) * 12 + (now.getMonth() - d.getMonth());
               if (months < 0) return '';
               const yrs = Math.floor(months / 12);
               const rem = months % 12;
               const parts = [];
               if (yrs > 0) parts.push(`${yrs} year${yrs > 1 ? 's' : ''}`);
               if (rem > 0) parts.push(`${rem} month${rem > 1 ? 's' : ''}`);
               return parts.length > 0 ? parts.join(' ') : '0 months';
          } catch (e) {
               return '';
          }
     };

     const getSubmittedDate = (ev) => {
          if (!ev) return '';
          const candidates = ['submitted_on', 'submittedOn', 'submitted_at', 'submittedAt', 'submitted_date', 'submittedDate', 'updated_at', 'updatedAt', 'updated_on', 'updatedOn', 'updated_dtm', 'updatedDtm', 'created_at', 'createdAt', 'created_on', 'createdOn', 'created_dtm', 'createdDtm'];
          for (const k of candidates) {
               const v = ev[k];
               if (v === undefined || v === null) continue;
               const s = String(v).trim();
               if (!s) continue;
               if (/^0{2,4}[-:\s0]+$/.test(s)) continue;
               if (s === '0000-00-00' || s === '0000-00-00 00:00:00') continue;
               return s;
          }
          return '';
     };

     const handleDownload = () => {
          const rows = filteredEvaluations || [];
          if (rows.length === 0) {
               alert('No records to download');
               return;
          }
          const esc = (v) => '"' + String(v ?? '').replace(/"/g, '""') + '"';
          const fields = ['emp_code', 'emp_name', 'quarter', 'centre', 'created_dtm', 'updated_by', 'updated_dtm', 'total_points', 'total_admin_points', 'admin_emp_code', 'admin_name', 'specialty', 'timing', 'mobile', 'employment_type', 'doj', 'vdc_exp', 'dept', 'year', 'is_submitted', 'submitted_on'];
          const labels = ['Emp Code', 'Name', 'Quarter', 'Centre', 'Created At', 'Updated By', 'Updated At', 'Total Points', 'Total Admin Points', 'Admin Emp Code', 'Admin Name', 'Specialty', 'Timing', 'Mobile', 'Employment Type', 'DOJ', 'VDC Exp', 'Department', 'Year', 'Submitted', 'Submitted On'];

          const resolveDoj = (r) => r.doj || r.date_of_joining || r.join_date || r.joined_on || r.joinedOn || r.created_at || r.created_dtm || '';

          const csvRows = [labels.map(esc).join(',')].concat(rows.map(r => fields.map(f => {
               if (f === 'is_submitted') return esc(r.is_submitted === 'Y' ? 'Yes' : 'No');
               if (f === 'submitted_on') return esc((r.submitted_on || r.submitted_at || r.updated_at || r.created_at || ''));
               if (f === 'vdc_exp') {
                    const v = r.vdc_exp || r.vdc_experience || r.vdcExp || '';
                    if (v && String(v).trim() !== '') return esc(v);
                    const fromDoj = computeVdc(resolveDoj(r));
                    return esc(fromDoj || '');
               }
               return esc(r[f]);
          }).join(',')));

          const csvContent = csvRows.join('\r\n');
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const fileName = `lab_director_dashboard_${filters.emp_code || 'ALL'}_${filters.quarter || 'ALL'}_${filters.year || 'ALL'}.csv`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
     };


     return (
          <div style={{ padding: 24, backgroundColor: '#f7f9fc', minHeight: '100vh' }}>
               <div style={{ margin: '0 auto' }}>
                    <Card>
                         <Card.Body>
                              <Form style={{ marginTop: 12 }} onSubmit={(e) => { e.preventDefault(); /* filters state already drives fetch */ }}>
                                   <Row className="align-items-end">
                                        <Col md={2}>
                                             <Form.Group>
                                                  <Form.Label>Quarter</Form.Label>
                                                  <Form.Control as="select" value={filters.quarter} onChange={e => setFilters(f => ({ ...f, quarter: e.target.value }))}>
                                                       {quarters.map(q => <option key={q.value} value={q.value}>{q.label}</option>)}
                                                  </Form.Control>
                                             </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                             <Form.Group>
                                                  <Form.Label>Year</Form.Label>
                                                  <Form.Control as="select" value={filters.year} onChange={e => setFilters(f => ({ ...f, year: e.target.value }))}>
                                                       <option value="">All</option>
                                                       {years.map(y => <option key={y} value={y}>{y}</option>)}
                                                  </Form.Control>
                                             </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                             <Form.Group>
                                                  <Form.Label>Consultant</Form.Label>
                                                  <Form.Control as="select" value={filters.emp_code} onChange={e => setFilters(f => ({ ...f, emp_code: e.target.value }))}>
                                                       <option value="">All</option>
                                                       {consultants.map(c => (
                                                            <option key={c.employee_code || c.emp_id} value={c.employee_code || c.emp_id}>{(c.employee_name || c.comp_name) + ' (' + (c.employee_code || c.employee_code || c.emp_id) + ')'}</option>
                                                       ))}
                                                  </Form.Control>
                                             </Form.Group>
                                        </Col>
                                        <Col md={2} style={{ display: 'flex', alignItems: 'center' }}>
                                             <Form.Group style={{ marginBottom: 0 }}>
                                                  <Form.Check type="checkbox" id="pendingAdmin" label="Pending HOD Reviews" checked={showPendingAdmin} onChange={e => setShowPendingAdmin(e.target.checked)} />
                                             </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                             <div style={{ display: 'flex', gap: 8 }}>
                                                  <Button
                                                       variant="primary"
                                                       size="sm"
                                                       onClick={() => setFilters(f => ({ ...f }))}
                                                       style={{ padding: '4px 8px', height: 32, fontSize: 13, lineHeight: 1, borderRadius: 6, minWidth: 72 }}
                                                  >
                                                       Apply
                                                  </Button>
                                                  <Button
                                                       variant="light"
                                                       size="sm"
                                                       onClick={() => setFilters({ emp_code: '', quarter: '', year: new Date().getFullYear().toString() })}
                                                       style={{ padding: '4px 8px', height: 32, fontSize: 13, lineHeight: 1, borderRadius: 6, minWidth: 72 }}
                                                  >
                                                       Reset
                                                  </Button>
                                                  <Button
                                                       variant="success"
                                                       size="sm"
                                                       onClick={handleDownload}
                                                       disabled={(filteredEvaluations || []).length === 0}
                                                       style={{ padding: '4px 10px', height: 32, fontSize: 13, lineHeight: 1, borderRadius: 6, minWidth: 92 }}
                                                  >
                                                       Download Excel
                                                  </Button>
                                             </div>
                                        </Col>
                                   </Row>
                              </Form>

                              <Row style={{ marginTop: 8, gap: 0.1 }}>
                                   <Col md={2}>
                                        <Card className="mb-2" style={{ minHeight: 120 }}>
                                             <Card.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '10px' }}>
                                                  <div style={{ fontSize: 12, color: '#666' }}>Total Consultants Allowed  </div>
                                                  <div style={{ fontSize: 20, fontWeight: 700 }}>{dashboardData?.totalConsultants ?? consultants.length}</div>
                                             </Card.Body>
                                        </Card>
                                   </Col>
                                   <Col md={2}>
                                        <Card className="mb-2" style={{ minHeight: 120 }}>
                                             <Card.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '10px' }}>
                                                  <div style={{ fontSize: 12, color: '#666' }}>Total Submissions</div>
                                                  <div style={{ fontSize: 20, fontWeight: 700 }}>{metrics.submittedCount ?? 0}</div>
                                             </Card.Body>
                                        </Card>
                                   </Col>
                                   <Col md={2}>
                                        <Card className="mb-2" style={{ minHeight: 120 }}>
                                             <Card.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '10px' }}>
                                                  <div style={{ fontSize: 12, color: '#666' }}>Total Drafts</div>
                                                  <div style={{ fontSize: 20, fontWeight: 700 }}>{metrics.draftCount ?? 0}</div>
                                             </Card.Body>
                                        </Card>
                                   </Col>
                                   <Col md={2}>
                                        <Card className="mb-2" style={{ minHeight: 120 }}>
                                             <Card.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '10px' }}>
                                                  <div style={{ fontSize: 12, color: '#666' }}>Total Completed Assessments</div>
                                                  <div style={{ fontSize: 20, fontWeight: 700 }}>{computedCompletedAdminCount ?? (metrics.completedAdminCount ?? 0)}</div>
                                             </Card.Body>
                                        </Card>
                                   </Col>
                                   <Col md={2}>
                                        <Card className="mb-2" style={{ minHeight: 120 }}>
                                             <Card.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '10px' }}>
                                                  <div style={{ fontSize: 12, color: '#666' }}>Pending for HOD Reviews</div>
                                                  <div style={{ fontSize: 20, fontWeight: 700 }}>{computedPendingAdminCount ?? (metrics.pendingAdminCount ?? 0)}</div>
                                             </Card.Body>
                                        </Card>
                                   </Col>
                                   <Col md={2}>
                                        <Card className="mb-2" style={{ minHeight: 120 }}>
                                             <Card.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '10px' }}>
                                                  <div style={{ fontSize: 12, color: '#666' }}>Count of Pending Self Assessments</div>
                                                  <div style={{ fontSize: 20, fontWeight: 700 }}>{metrics.pendingSelfAssessment ?? 0}</div>
                                             </Card.Body>
                                        </Card>
                                   </Col>
                              </Row>

                              <div style={{ marginTop: 18 }}>
                                   <Table striped bordered hover size="sm">
                                        <thead>
                                             <tr>
                                                  <th style={{ width: 40 }}>#</th>
                                                  <th>Emp Code</th>
                                                  <th>Name</th>
                                                  <th>Centre</th>
                                                  <th>Quarter</th>
                                                  <th>Year</th>
                                                  <th>Submitted</th>
                                                  <th>Submitted On</th>
                                                  <th>Status</th>
                                                  <th style={{ width: 96, textAlign: 'center' }}>Actions</th>
                                             </tr>
                                        </thead>
                                        <tbody>
                                             {filteredEvaluations.length === 0 && (
                                                  <tr><td colSpan={10} className="text-center">No evaluations found</td></tr>
                                             )}
                                             {paginatedEvaluations.map((ev, idx) => (
                                                  <tr key={ev.id} style={{ background: ev.is_deleted === 'Y' ? '#fff6f6' : undefined }}>
                                                       <td>{(currentPage - 1) * pageSize + idx + 1}</td>
                                                       <td>{ev.emp_code}</td>
                                                       <td>{ev.emp_name}</td>
                                                       <td>{ev.centre}</td>
                                                       <td>{ev.quarter}</td>
                                                       <td>{ev.year}</td>
                                                       <td style={{ textAlign: 'center' }}>{ev.is_submitted === 'Y' ? 'Yes' : 'No'}</td>
                                                       <td style={{ whiteSpace: 'nowrap' }}>{ev.is_submitted === 'Y' ? formatDateOnly(getSubmittedDate(ev)) : ''}</td>
                                                       <td>
                                                            {ev.is_deleted === 'Y' ? (
                                                                 <span style={{ color: '#d9534f', fontWeight: 600 }}>Deleted</span>
                                                            ) : (() => {
                                                                 const adminCode = ev && (ev.admin_emp_code || ev.adminCode || ev.admin_emp || ev.admin_empcode);
                                                                 const adminName = ev && (ev.admin_name || ev.adminName || ev.admin);
                                                                 const hasAdmin = adminCode || adminName;
                                                                 if (!hasAdmin) return <span style={{ color: '#ff8c00', fontWeight: 600 }}>Pending HOD Reviews</span>;
                                                                 if (ev.is_submitted === 'Y') return <span style={{ color: '#28a745', fontWeight: 600 }}>Reviews Done</span>;
                                                                 return <span style={{ color: '#6c757d' }}>Draft</span>;
                                                            })()
                                                            }</td>
                                                       <td style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'center' }}>
                                                            <button
                                                                 type="button"
                                                                 title="View"
                                                                 className="btn p-0"
                                                                 onClick={() => navigate(`/admin-evaluations/${ev.id}`)}
                                                                 aria-label={`View evaluation ${ev.id}`}
                                                                 style={{ border: 'none', background: 'transparent', padding: '2px', color: '#5b49ff' }}
                                                            >
                                                                 <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
                                                                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8z" fill="none" stroke="currentColor" strokeWidth="0.9" />
                                                                      <circle cx="8" cy="8" r="2.2" fill="currentColor" />
                                                                 </svg>
                                                            </button>

                                                            <button
                                                                 type="button"
                                                                 title={ev.is_submitted === 'Y' ? 'Edit' : 'Edit (disabled until submitted)'}
                                                                 className="btn p-0"
                                                                 onClick={() => ev.is_submitted === 'Y' && navigate(`/admin-evaluations/${ev.id}/edit`)}
                                                                 aria-label={`Edit evaluation ${ev.id}`}
                                                                 style={{ border: 'none', background: 'transparent', padding: '2px', color: ev.is_submitted === 'Y' ? '#5b49ff' : '#bdbdbd' }}
                                                                 disabled={ev.is_submitted !== 'Y'}
                                                            >
                                                                 <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
                                                                      <path d="M12.146.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708L5.207 13.5 3 13l.5-2.207L12.146.146z" fill="currentColor" />
                                                                 </svg>
                                                            </button>
                                                       </td>
                                                  </tr>
                                             ))}
                                        </tbody>
                                   </Table>

                                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                                        <div style={{ fontSize: 13, color: '#666' }}>
                                             {filteredEvaluations.length > 0 ? (
                                                  <>Showing {(filteredEvaluations.length === 0) ? 0 : ((currentPage - 1) * pageSize + 1)} to {Math.min(filteredEvaluations.length, currentPage * pageSize)} of {filteredEvaluations.length}</>
                                             ) : 'No records'}
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                             <select value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setCurrentPage(1); }} style={{ padding: '2px 6px', fontSize: 12, height: 30 }}>
                                                  <option value={5}>5</option>
                                                  <option value={10}>10</option>
                                                  <option value={20}>20</option>
                                                  <option value={50}>50</option>
                                             </select>

                                             <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                                  <button
                                                       className="btn"
                                                       onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                                       disabled={currentPage === 1}
                                                       style={{ padding: 6, minWidth: 30, height: 30, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, background: '#fff', border: '1px solid #e6e6e6' }}
                                                       aria-label="Previous page"
                                                  >
                                                       <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10 12L6 8l4-4" stroke="#333" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                                       </svg>
                                                  </button>

                                                  {Array.from({ length: Math.max(0, totalPages) }, (_, i) => i + 1).slice(Math.max(0, currentPage - 4), Math.min(totalPages, currentPage + 3)).map(p => (
                                                       <button
                                                            key={p}
                                                            onClick={() => setCurrentPage(p)}
                                                            aria-label={`Page ${p}`}
                                                            style={{
                                                                 padding: 0,
                                                                 width: 28,
                                                                 height: 28,
                                                                 borderRadius: 14,
                                                                 display: 'inline-flex',
                                                                 alignItems: 'center',
                                                                 justifyContent: 'center',
                                                                 fontSize: 12,
                                                                 lineHeight: '1',
                                                                 cursor: 'pointer',
                                                                 border: p === currentPage ? 'none' : '1px solid #e6e6e6',
                                                                 background: p === currentPage ? '#5b49ff' : '#fff',
                                                                 color: p === currentPage ? '#fff' : '#333'
                                                            }}
                                                       >{p}</button>
                                                  ))}

                                                  <button
                                                       className="btn"
                                                       onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                                       disabled={currentPage === totalPages}
                                                       style={{ padding: 6, minWidth: 30, height: 30, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, background: '#fff', border: '1px solid #e6e6e6' }}
                                                       aria-label="Next page"
                                                  >
                                                       <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6 4l4 4-4 4" stroke="#333" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                                       </svg>
                                                  </button>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </Card.Body>
                    </Card>
               </div>
          </div>
     );
};

export default LAB_DIRECTOR_Dashboard;
